const state = {
    repeatPage: 1 
}

const mutations = {
    SET_REPEATPAGE(state,value){
        state.repeatPage = value
    }
}

const actions  = {

}


export default {
    state,
    mutations,
    actions
}  


// WEBPACK FOOTER //
// ./src/store/modules/baidu.js